import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dashboard-area company-dashboard pt-120 mb-120" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row g-lg-4 gy-5 mb-90" }
const _hoisted_4 = { class: "col-lg-12" }
const _hoisted_5 = { class: "form-wrapper" }
const _hoisted_6 = { class: "profile-form" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "section-title2" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "d-flex align-items-baseline gap-1" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "assets/images/icon/profile-settings.svg",
      alt: ""
    }),
    /*#__PURE__*/_createTextVNode(" Profile Settings ")
  ])
], -1)
const _hoisted_8 = { class: "change-password-area mb-40" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-12" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "info-title" }, [
    /*#__PURE__*/_createElementVNode("h6", null, "Change Your Password"),
    /*#__PURE__*/_createElementVNode("div", { class: "dash" })
  ])
], -1)
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "form-inner mb-25" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { for: "password" }, "New Password*", -1)
const _hoisted_14 = { class: "input-area" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", {
  src: "assets/images/icon/lock-2.svg",
  alt: ""
}, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-eye-slash",
  id: "togglePassword"
}, null, -1)
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<div class=\"col-md-6\"><div class=\"form-inner mb-25\"><label for=\"password2\">Confirm Password*</label><div class=\"input-area\"><img src=\"assets/images/icon/lock-2.svg\" alt=\"\"><input type=\"password\" name=\"confirmpassword\" id=\"password2\" placeholder=\"Confirm Password\"><i class=\"bi bi-eye-slash\" id=\"togglePassword2\"></i></div></div></div>", 1)
const _hoisted_18 = { class: "col-md-12 pt-10" }
const _hoisted_19 = { class: "form-inner" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_company_menu = _resolveComponent("company-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_company_menu),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("form", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _createElementVNode("div", _hoisted_14, [
                        _hoisted_15,
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.changepass.password) = $event)),
                          type: "password",
                          name: "password",
                          id: "password",
                          placeholder: "Password"
                        }, null, 512), [
                          [_vModelText, _ctx.changepass.password]
                        ]),
                        _hoisted_16
                      ])
                    ])
                  ]),
                  _hoisted_17,
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("button", {
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updatePassword && _ctx.updatePassword(...args))),
                        class: "primry-btn-1 lg-btn w-unset",
                        type: "button"
                      }, "Update Change")
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}